//export const baseUrl = "http://localhost:1555/";
//export const baseUrl = "http://154.62.109.155:1555/";
export const baseUrl = "https://api.his.rsicmohali.com/";
